// extracted by mini-css-extract-plugin
export var root = "Portfolio-module--root--TxMu7";
export var title = "Portfolio-module--title--lhWz9";
export var content = "Portfolio-module--content--dPkS7";
export var footer = "Portfolio-module--footer--4FMuT";